import CitySEOHead from "@/components/feature/CitySEOHead";
import BentonvilleHeroSection from "./components/HeroSection";
import BentonvilleStickyNav from "./components/StickyNav";
import BentonvilleProcessingTimeSection from "./components/ProcessingTimeSection";
import BentonvilleServicesSection from "./components/ServicesSection";
import BentonvilleLocalAreaSection from "./components/LocalAreaSection";
import BentonvilleTravelTimingSection from "./components/TravelTimingSection";
import BentonvilleDestinationsSection from "./components/DestinationsSection";
import BentonvilleTestimonialsSection from "./components/TestimonialsSection";
import BentonvilleAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import BentonvilleComparisonSection from "./components/ComparisonSection";
import BentonvilleMistakesSection from "./components/MistakesSection";
import BentonvilleHowItWorksSection from "./components/HowItWorksSection";
import BentonvilleFAQSection, { faqs } from "./components/FAQSection";
import BentonvilleHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import BentonvilleFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const pageTitle = "Emergency Passport Bentonville, AR — Expedited & Fast Passport Service | Fast Passport Center";
const pageDescription = "Emergency and expedited passport services in Bentonville, AR — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Walmart Home Office executives, Crystal Bridges staff, and NWA families.";

const servicesList = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
];

export default function BentonvillePage() {
  return (
    <>
      <CitySEOHead
        city="Bentonville"
        state="Arkansas"
        stateAbbr="AR"
        route="/cities/bentonville"
        title={pageTitle}
        description={pageDescription}
        ogTitle={pageTitle}
        ogDescription={pageDescription}
        twitterTitle={pageTitle}
        twitterDescription={pageDescription}
        geoPlacename="Bentonville, Arkansas"
        geoPosition="36.3729;-94.2088"
        keywords="expedited passport Bentonville, emergency passport Bentonville AR, same day passport Bentonville, fast passport Arkansas, passport renewal Bentonville, Northwest Arkansas passport"
        faqs={faqs}
        servicesSchema={servicesList}
        statePageName="Arkansas"
        statePageRoute="/states/arkansas"
        lastModified="2026-06-09"
        serviceAreaDesc="Fast Passport Center does not have a physical office in Bentonville — we serve this area remotely. Emergency and expedited passport services as fast as 24 hours for Walmart Home Office, Crystal Bridges, and NWA travelers."
      />

      <div className="font-sans">
        <BentonvilleHeroSection />
        <BentonvilleStickyNav />
        <BentonvilleProcessingTimeSection />
        <BentonvilleLocalAreaSection />
        <BentonvilleServicesSection />
        <BentonvilleTravelTimingSection />
        <BentonvilleDestinationsSection />
        <BentonvilleTestimonialsSection />
        <BentonvilleAcceptanceFacilitiesSection />
        <BentonvilleComparisonSection />
        <BentonvilleMistakesSection />
        <BentonvilleHowItWorksSection />
        <BentonvilleFAQSection />
        <BentonvilleHelpfulResourcesSection />
        <SEOCrossLinks currentRoute="/cities/bentonville" state="AR" />
        <BentonvilleFinalCTA />
      </div>
    </>
  );
}